export const randomId = (prefix = "") => {
    const id = (Math.random() + Math.random() + 1).toString(36).substring(2);
    return `${prefix}-${id}`;
};
//# sourceMappingURL=ui-utils.js.map